import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './alert.component';
import { MatDialogModule } from '@angular/material/dialog';

import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [AlertComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    RouterModule,
    TranslateModule.forChild()
  ],
  exports: [AlertComponent]
})
export class AlertModule {}
